// import React from "react";
// import { Container, Row, Col } from "react-bootstrap";
// import ConsultingHeroImg from "../../asset/Accounting.png"; // Hero background image
// import ConsultingCenterImg from "../../asset/image1.png"; // Center image
// import ConsultingRightImg from "../../asset/image3.png"; // Right-side image
// import LineImg from "../../asset/line1.png"; // Line image
// import pointImg from "../../asset/point.png"; // Icon for points
// import "./ServiceBusiness.css"; // Can reuse ServiceAccounting.css if identical

// const ServiceConsulting = () => {
//   return (
//     <div>
//       {/* Hero Section */}
//       <div
//         className="services-hero"
//         style={{
//           backgroundImage: `url(${ConsultingHeroImg})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           height: "88vh",
//           position: "relative",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           textAlign: "center",
//         }}
//       >
//         {/* Dark Overlay */}
//         <div className="services-overlay"></div>
      
//         {/* Hero Content */}
//         <div className="services-content">
//           <h1 className="services-heading">Building Trust Through Transparency</h1>
//           <p className="services-paragraph">
//             We deliver through audits and assurance services that enhance credibility,
//             accuracy and confidence for your stakeholders.
//           </p>
//         </div>
//       </div>

//       {/* Consulting Image Section */}
//       <div className="detail-section">
//         <Container className="text-center">
//           <div className="d-flex align-items-center justify-content-center flex-wrap">
//             <img src={LineImg} alt="line-left" className="side-line" />

//             <div className="center-image-wrapper">
//               {/* <img src={ConsultingCenterImg} alt="Consulting Service" className="side-image" /> */}
//               <div className="image-text">Management Consultancy Services</div>
//             </div>

//             <img src={LineImg} alt="line-right" className="side-line mirrored" />
//           </div>
//         </Container>
//       </div>

//       {/* Service Points Section */}
//       <div className="service-image-section">
//         <Container>
//           <Row className="align-items-center">
//             {/* Left Column with Points */}
//             <Col md={6}>
//               <ul className="service-points">
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Start-up Advisory
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   FEMA/RBI Compliances
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Tax Planning
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Loan & Funding Application
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Management Services & Risk Analysis
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Working Capital Requirement Assessment
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Accounting & Costing System Design and Implementation
//                 </li>
//                 <li>
//                   <img src={pointImg} alt="icon" className="point-icon" />
//                   Advice on Mergers, Business Sale,Due Diligence & valuations
//                 </li>
//               </ul>
//             </Col>

//             {/* Right Column with Image */}
//             <Col md={6} className="text-center text-md-end">
//               <img src={ConsultingRightImg} alt="Service Detail" className="service-right-image" />
//             </Col>
//           </Row>
//         </Container>
//       </div>
//     </div>
//   );
// };

// export default ServiceConsulting;


import React, { memo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ConsultingRightImg from "../../asset/consultancy.webp"; // Right-side image
import LineImg from "../../asset/line1.png";            // Line image
import consultingImg from "../../asset/Accounting.webp";
import pointImg from "../../asset/point.png";           // Icon for points
import "./ServiceBusiness.css";

// ✅ Memoized service point component
const ServicePoint = memo(({ text }) => (
  <li>
    <img src={pointImg} alt="icon" className="point-icon" loading="lazy" />
    {text}
  </li>
));

const ServiceConsulting = () => {
  const servicePoints = [
    "Start-up Advisory",
    "FEMA/RBI Compliances",
    "Tax Planning",
    "Loan & Funding Application",
    "Management Services & Risk Analysis",
    "Working Capital Requirement Assessment",
    "Accounting & Costing System Design and Implementation",
    "Advice on Mergers, Business Sale, Due Diligence & Valuations",
  ];

  return (
    <div>
      {/* Hero Section */}
      <div className="services-hero consulting-hero"
      style={{
    backgroundImage: `url(${ consultingImg})`, // ✅ Use template literal with imported image
  }}
      >
        <div className="services-overlay"></div>
        <div className="services-content">
          <h1 className="services-heading">Building Trust Through Transparency</h1>
          <p className="services-paragraph">
            We deliver through management consultancy services that enhance credibility,
            accuracy, and confidence for your stakeholders.
          </p>
        </div>
      </div>

      {/* Consulting Center Section */}
      <div className="detail-section">
        <Container className="text-center">
          <div className="d-flex align-items-center justify-content-center flex-wrap">
            <img src={LineImg} alt="line-left" className="side-line" loading="lazy" />
            <div className="center-image-wrapper">
              <div className="image-text">Management Consultancy Services</div>
            </div>
            <img src={LineImg} alt="line-right" className="side-line mirrored" loading="lazy" />
          </div>
        </Container>
      </div>

      {/* Service Points Section */}
      <div className="service-image-section">
        <Container>
          <Row className="align-items-center">
            {/* Left Column with Points */}
            <Col md={6}>
              <ul className="service-points">
                {servicePoints.map((point, index) => (
                  <ServicePoint key={index} text={point} />
                ))}
              </ul>
            </Col>

            {/* Right Column with Image */}
            <Col md={6} className="text-center text-md-end">
              <img
                src={ConsultingRightImg}
                alt="Service Detail"
                className="service-right-image"
                loading="lazy"
              />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default memo(ServiceConsulting);
